import React from "react";
import SurveyQuestion from "./SurveyQuestion";
import { ESectionDivider } from "../../../libs/ui";

const SurveyGroup = ({ group, groupIndex, onAnswerChange }: any) => {
  return (
    <>
      <div className="border p-4 rounded bg-slate-100">
        <h3 className="font-bold text-lg mb-2">
          {group.question_Section_Title}
        </h3>

        {group.question_Section_Description && (
          <p className="text-sm text-gray-500 mb-3">
            {group.question_Section_Description}
          </p>
        )}

        {/* ✅ GRID FIX */}
        <div
          className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4`}
        >
          {group.questions.map((q: any, index: number) => (
            <SurveyQuestion
              key={index}
              question={q}
              groupIndex={groupIndex}
              questionIndex={index}
              onAnswerChange={onAnswerChange}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SurveyGroup;
